import { del, get, post, put } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const listEvents = async (page_at, page_size,from_date, to_date, event_name, sort_by, sort_order, filters) => {
    if (shouldLogApiCalls) {
        console.log('List events attempt:', { page_at, page_size, from_date, to_date, event_name, sort_by, sort_order, filters });
    }
    
    return post('/event', { page_at, page_size, from_date, to_date, event_name, sort_by, sort_order, with_stats: true, filters });
}

export const getBoards = async () => {
    return get('/board');
}

export const createBoard = async (name) => {
    return post('/board', { name });
}

export const updateBoard = async (id, name) => {
    return put(`/board/${id}`, { name });
}

export const deleteBoard = async (id) => {
    return del(`/board/${id}`);
}

export const listReports = async (page_at, page_size, search_term, sort_by, sort_order) => {
    const searchParam = search_term ? `&search_term=${encodeURIComponent(search_term)}` : '';
    const sortParam = sort_by && sort_order ? `&sort_by=${encodeURIComponent(sort_by)}&sort_order=${encodeURIComponent(sort_order)}` : '';
    return get(`/report?page_at=${page_at}&page_size=${page_size}${searchParam}${sortParam}`);
}

export const getReport = async (id, from_date, to_date) => {
    if (from_date && to_date) {
        return get(`/report/${id}?start_date=${from_date}&end_date=${to_date}`);
    } else {
        return get(`/report/${id}`);
    }
}

export const listEventNames = async () => {
    return get('/event/options');
}

export const updateReport = async (report) => {
    return put(`/report/${report.id}`, report);
}

export const createReport = async (report) => {
    return post('/report', report);
}

export const deleteReport = async (id) => {
    return del(`/report/${id}`);
}

export const getBoard = async (boardId) => {
    return get(`/board/${boardId}`);
}